import DetailCard from "../components/details"
import SimilarDishesCarousel from "../components/SimilarDishesCarousel"
import {Footer} from "../components/footer"
import NavBar from "../components/nav"
import { Link,useParams } from "react-router-dom"
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import axios from "axios";
import SkeletonDishDetail from '../components/skeletons/SkeletonDishDetail';
import API_BASE_URL from '../config/api';
import promotionApi from '../services/promotionApi';

export default function DishDetails(){
    const { t } = useTranslation();
    const { id } = useParams();
    const [dish, setDish] = useState(null);
    const [similarDishes, setSimilarDishes] = useState([]);
    const [promotedDishIds, setPromotedDishIds] = useState(new Set());
    const [isLoading, setIsLoading] = useState(true);
    const [similarLoading, setSimilarLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Scroll vers le haut au montage et quand l'id change
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [id]);

    useEffect(() => {
      const fetchDishAndSimilar = async () => {
        try {
          setIsLoading(true);
          setSimilarLoading(true);
          setError(null);

          const res = await axios.get(`${API_BASE_URL}/dishes/${id}`);
          const fetchedDish = res.data;
          const promotions = await promotionApi.getPublicPromotions({
            restaurant_id: fetchedDish.restaurant_id,
            status: 'active',
            limit: 50
          });
          const promotionDishIds = new Set(
            (Array.isArray(promotions) ? promotions : [])
              .flatMap((promo) => Array.isArray(promo?.dish_ids) ? promo.dish_ids : [])
              .map((dishId) => Number(dishId))
              .filter((dishId) => Number.isFinite(dishId) && dishId > 0)
          );

          setPromotedDishIds(promotionDishIds);
          setDish({
            ...fetchedDish,
            is_promoted: promotionDishIds.has(Number(fetchedDish.id))
          });
          setIsLoading(false);

          const similarRes = await axios.get(`${API_BASE_URL}/dishes/similar/${fetchedDish.id}`);
          const similarRows = Array.isArray(similarRes.data) ? similarRes.data : [];
          setSimilarDishes(
            similarRows.map((row) => ({
              ...row,
              is_promoted: promotionDishIds.has(Number(row.id))
            }))
          );
          setSimilarLoading(false);
        } catch (err) {
          console.error("Erreur de chargement :", err);
          setError(t('product.dishNotFoundUnavailable'));
          setIsLoading(false);
          setSimilarLoading(false);
        }
      };
  
      fetchDishAndSimilar();
    }, [id]);
  
    if (isLoading) {
      return (
        <>
          <NavBar/>
          <SkeletonDishDetail />
          <Footer/>
        </>
      );
    }

    if (error || !dish) {
      return (
        <>
          <NavBar/>
          <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4">
            <div className="max-w-xl mx-auto text-center">
              <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
                <svg viewBox="0 0 24 24" fill="none" stroke="rgb(180,180,180)" strokeWidth={1.5} className="w-8 h-8"><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></svg>
              </div>
              <p className="text-gray-700 mb-4">{error || t('product.dishNotFound')}</p>
              <Link to="/" className="font-semibold text-sm underline text-gray-900">
                {t('product.backToHome')}
              </Link>
            </div>
          </div>
          <Footer/>
        </>
      );
    }

    return(
       <>
            <NavBar/>
            <div className='min-h-screen bg-namke-white'>
                {/* Breadcrumb */}
                <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-4'>
                    <p className="text-sm text-namke-black/70 font-normal hover:text-namke-black transition-colors">
                        <Link to='/' className="hover:underline">{t('product.home')}</Link>
                        <span className="mx-2">/</span>
                        <span className="text-namke-black/70">{t('product.dishDetails')}</span>
                    </p>
                </div>

                {/* Main Content */}
                <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8'>
                    <DetailCard dish={dish}/>

                    {/* Plats similaires */}
                    {!similarLoading && (
                      <SimilarDishesCarousel
                        title={t('product.similarDishes')}
                        dishes={similarDishes.map(d => ({ ...d, is_promoted: promotedDishIds.has(Number(d.id)) || d.is_promoted }))}
                      />
                    )}
                </div>
            </div>
            <Footer/> 
       </>
    )
}